import { Component, OnInit } from '@angular/core';
import { CommonProjectDataService } from "../../_services/common-project-data.service";
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { CartService } from '../../_services/cart.service';

@Component({
  selector: 'app-store-master-layout',
  templateUrl: './store-master-layout.component.html',
  styleUrls: ['./store-master-layout.component.css']
})
export class StoreMasterLayoutComponent implements OnInit {
  public logoUrl: any;
  public storeProject: any = {};
  public totalCartProduct = 0;
  constructor(private CommonProjectDataService: CommonProjectDataService,
    private titleService: Title,
    private router: Router,
    private cartService: CartService
  ) { }

  ngOnInit() {
    this.cartService.cartQuantity$.subscribe(quantity => {
      this.totalCartProduct = quantity;
    });
    this.CommonProjectDataService.storeLogo.subscribe(logoUrl => {
      this.logoUrl = logoUrl
    })
    this.logoUrl = localStorage.getItem('storeLogo');
    this.storeProject = JSON.parse(localStorage.getItem("storeData"));
    if (this.storeProject) {
      this.titleService.setTitle(this.storeProject.name);
      $("#appPrintLifeFavicon").attr("href", this.storeProject.favicon_img);
    }
    this.totalCartProduct = localStorage.getItem('totalCartProduct') ? parseInt(localStorage.getItem('totalCartProduct')) : 0;


  }
  onActivate(event) {
    window.scroll(0, 0);

  }
  phoneFormate(phoneNumber) {
    let newStr = "";
    let i = 0;
    //for (; i < Math.floor(rawNum.length / 2) - 1; i++) {
    let Strfirst = "(" + phoneNumber.substr(0, 3) + ")";
    let st = " " + phoneNumber.substr(3, 3) + "-" + phoneNumber.substr(6, 4);
    newStr = Strfirst + st;
    //}

    return newStr;
  }


}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-store-product/store-master-layout/store-master-layout.component.ts